import { type JSX } from "react";
import clsx from "clsx";

type WebcamCaptureMaskProps = {
    className: string;
}

const WebcamCaptureMask = ({ className }: WebcamCaptureMaskProps): JSX.Element => {

    const scaleFactor = 1.2;
    const centerX = 160;
    const centerY = 185.259;

    const maskShape = `
  M ${centerX} ${centerY} 
  C ${centerX + (103.898 - centerX) * scaleFactor} ${centerY + (185.259 - centerY) * scaleFactor} 
    ${centerX + (87.5557 - centerX) * scaleFactor} ${centerY + (223.934 - centerY) * scaleFactor} 
    ${centerX + (87.5557 - centerX) * scaleFactor} ${centerY + (277.158 - centerY) * scaleFactor}
  C ${centerX + (87.5557 - centerX) * scaleFactor} ${centerY + (330.382 - centerY) * scaleFactor} 
    ${centerX + (124.148 - centerX) * scaleFactor} ${centerY + (378 - centerY) * scaleFactor} 
    ${centerX + (160 - centerX) * scaleFactor} ${centerY + (378 - centerY) * scaleFactor}
  C ${centerX + (195.852 - centerX) * scaleFactor} ${centerY + (378 - centerY) * scaleFactor} 
    ${centerX + (232.445 - centerX) * scaleFactor} ${centerY + (330.382 - centerY) * scaleFactor} 
    ${centerX + (232.445 - centerX) * scaleFactor} ${centerY + (277.158 - centerY) * scaleFactor}
  C ${centerX + (232.445 - centerX) * scaleFactor} ${centerY + (223.934 - centerY) * scaleFactor} 
    ${centerX + (216.102 - centerX) * scaleFactor} ${centerY + (185.259 - centerY) * scaleFactor} 
    ${centerX + (160 - centerX) * scaleFactor} ${centerY + (185.259 - centerY) * scaleFactor} 
  Z
`;

    return (
        <div className={clsx("", className)}>
            <svg width="100%" height="100%" viewBox="0 0 320 568" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="background-darkening-clip">
                    <rect width="6000" height="6000" x="-2000" y="-2000" fill="white" />
                    <path d={maskShape} fill="black"/>
                </mask>
                <rect mask="url(#background-darkening-clip)" width="6000" height="6000" x="-2000" y="-2000" opacity="0.5" fill="black" />
                <g filter="url(#filter0_i_1_1833)">
                    <path d={maskShape} fill="white" fillOpacity="0.02" />
                </g>
                <path d={maskShape} stroke="#F0F0F0" strokeWidth="4" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
                <line opacity="0.7" x1="160" y1="185.259" x2="160" y2="420.999" stroke="#F0F0F0" strokeWidth="0.89" strokeDasharray="7.11 2.37" vectorEffect="non-scaling-stroke" />
                <line opacity="0.7" x1="75.5557" y1="282" x2="246.4457" y2="282" stroke="#F0F0F0" strokeWidth="0.89" strokeDasharray="7.11 2.37" vectorEffect="non-scaling-stroke"/>
                <defs>
                    <filter id="filter0_i_1_1833" x="70.5557" y="184.259" width="206.889" height="250.741" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset/>
                        <feGaussianBlur stdDeviation="8.88889"/>
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"/>
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1_1833"/>
                    </filter>
                </defs>
            </svg>
        </div>
    );

}

export default WebcamCaptureMask;
